var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 4C14.0299 4 16.0965 4.85602 17.6202 6.37976C19.144 7.90349 20 9.97012 20 12.125C20 14.1375 19.2625 15.9875 18.05 17.4125L18.3875 17.75H19.375L25.625 24L23.75 25.875L17.5 19.625V18.6375L17.1625 18.3C15.6882 19.5585 13.8134 20.2499 11.875 20.25C9.72012 20.25 7.65349 19.394 6.12976 17.8702C4.60602 16.3465 3.75 14.2799 3.75 12.125C3.75 9.97012 4.60602 7.90349 6.12976 6.37976C7.65349 4.85602 9.72012 4 11.875 4ZM11.875 6.5C8.75 6.5 6.25 9 6.25 12.125C6.25 15.25 8.75 17.75 11.875 17.75C15 17.75 17.5 15.25 17.5 12.125C17.5 9 15 6.5 11.875 6.5Z",
    fill: "#A5A5A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.1b74dcec70bd47feaf4e14944876649c.svg";
export { ForwardRef as ReactComponent };